import * as React from 'react';
import { useCurrentRefinements, useClearRefinements } from 'react-instantsearch';
import { ButtonGhost } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { useItemsToClear } from '../../hooks/use-items-to-clear.js';

const ClearRefinements = ()=>{
    const { getLabel  } = useIntl();
    const { items  } = useCurrentRefinements();
    const itemsToClear = useItemsToClear(items);
    const { refine , canRefine  } = useClearRefinements({
        includedAttributes: itemsToClear.map((item)=>item.attribute
        )
    });
    if (!canRefine) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ButtonGhost, {
        onPress: refine,
        "data-t": "clear-refinements-button"
    }, getLabel('search.filters.clearAll'));
};

export { ClearRefinements as default };
//# sourceMappingURL=ClearRefinements.js.map
